import { useTranslation } from 'react-i18next';
import { useScrollReveal } from '@/hooks/useScrollReveal';

const alarmes = [
  'alarme_1', 'alarme_2', 'alarme_3', 'alarme_4', 'alarme_5',
  'alarme_6', 'alarme_7', 'alarme_8', 'alarme_9', 'alarme_10',
];

export default function SignauxAlarme() {
  const { t } = useTranslation('blogchoisir');
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>(0.1);

  return (
    <section ref={ref} id="alarmes" className="scroll-mt-28">
      <div className={`border-2 border-red-500/20 bg-red-50/50 rounded-xl p-6 md:p-8 transition-all duration-1000 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
      }`}>
        <div className="flex items-start gap-3 mb-5">
          <div className="w-10 h-10 shrink-0 flex items-center justify-center rounded-full bg-red-500/10">
            <i className="ri-alarm-warning-line text-red-500 text-lg" />
          </div>
          <h2 className="font-manrope font-bold text-slate-primary text-xl md:text-2xl">
            {t('alarmes_h2')}
          </h2>
        </div>

        <ul className="space-y-3">
          {alarmes.map((a, idx) => (
            <li
              key={idx}
              className={`flex gap-3 transition-all duration-700 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
              }`}
              style={{ transitionDelay: `${idx * 70 + 200}ms` }}
            >
              <span className="w-5 h-5 shrink-0 flex items-center justify-center rounded-full bg-red-500 text-white text-xs font-bold mt-0.5">
                {idx + 1}
              </span>
              <p className="text-slate-primary/80 text-sm md:text-base leading-relaxed">{t(a)}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}